<template>
  <div class="page" ref="page">
    <div class="navbar">
      <div class="logo">
        <img src="../assets/logo.png" style="width: 1rem" />
      </div>
      <div class="search" @click="$router.push('/result?keyword=' + hotk)">
        <input type="text" readonly :placeholder="hotk" />
      </div>
    </div>
    <van-swipe class="banner" :autoplay="3000" indicator-color="#C80928">
      <van-swipe-item v-for="(item,index) in banners" :key="index">
        <a style="display:block" :href="item.url? item.url : 'javascript:;'">
          <img :src="item.picture" />
        </a>
      </van-swipe-item>
    </van-swipe>

    <ul class="navbox">
      <li class="navbox-item" :class="active == item.product_category_id ? 'navbox-item-active' : ''" v-for="(item, index) in menus" :key="index" @click="fillter(item)">
        <div class="icon" :data-val="item.product_category">
          <img :src="require(`../assets/icon${item.id}.png`)" />
        </div>
        <p>{{item.product_category}}</p>
      </li>
    </ul>

    <div class="filter">
      <van-dropdown-menu>
        <van-dropdown-item v-model="sort" :options="option2" @change="toSort" />
      </van-dropdown-menu>
      <div class="filter-type" ref="mbType" @click.stop="openType">
        价格筛选<img src="../assets/icon_type.png" style="width: 0.1rem;margin-left: 0.05rem;" />
      </div>
    </div>

    <van-action-sheet v-model="typeFlag" title="筛选">
      <div class="sortBox">
        <h3>价格区间（元）</h3>
        <div class="interval">
          <input type="number" v-model="price_min" placeholder="自定义最低价" />
          <span></span>
          <input type="number" v-model="price_max" placeholder="自定义最高价" />
        </div>
        <div class="sortBox-btn">
          <div class="item item_min" @click="typeFlag = false">取消</div>
          <div class="item item_max" @click="submit_sort">确认</div>
        </div>
      </div>
    </van-action-sheet>

    <div class="mallbox">
      <!-- <ul class="mallbox-list"> -->
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list class="mallbox-list van-clearfix" v-model="loading" :finished="finished" finished-text="已经到底线了" @load="loadmore" :immediate-check="false" :offset="0">
          <div class="mallbox-list-item" v-for="(item, index) in list" :key="index" @touchstart="getTouchStart(item,index)" @touchmove="gtouchmove()" @touchend="getTouchEnd" @click="toDet(item)">
            <div class="displaying">
              <img :src="item.goodsimg" />
            </div>
            <p class="title">{{item.goodsname}}</p>
            <section class="price">
              <p><span>优选价</span><span>￥<strong>{{item.price}}</strong></span></p>
              <p><span>某东价</span><span>￥{{item.jdprice}}</span></p>
            </section>
            <!-- <div class="mask" v-show="show == index" @click="show = -1">
              <div class="wrapper" @click.stop="show = -1">
                <div class="btn">不感兴趣</div>
                <div class="btn">已经买了</div>
                <div class="btn">看过了</div>
                <div class="bot">找相似></div>
              </div>
            </div> -->
          </div>
        </van-list>
      </van-pull-refresh>
      <!-- </ul> -->
    </div>

    <Tabbar></Tabbar>
  </div>
</template>
<script>
import Tabbar from "../components/tabbar";
export default {
  components: {
    Tabbar
  },
  data() {
    return {
      banners: [],
      // banners: [{ "title": "1", "picture": "http:\/\/res.shiminjia.com\/files\/202107\/29\/175159_114.jpg", "url": "" }, { "title": "3", "picture": "http:\/\/res.shiminjia.com\/files\/202108\/02\/100015_99.jpg", "url": "http:\/\/city.shiminjia.com\/html\/zhihuiyouxuan\/#\/detail?id=11642" }, { "title": "2", "picture": "http:\/\/res.shiminjia.com\/files\/202107\/29\/175107_300.jpg", "url": "http:\/\/city.shiminjia.com\/html\/zhihuiyouxuan\/#\/detail?id=8175" }, { "title": "4", "picture": "http:\/\/res.shiminjia.com\/files\/202108\/02\/100033_403.jpg", "url": "http:\/\/city.shiminjia.com\/html\/zhihuiyouxuan\/#\/detail?id=7636" }, { "title": "5", "picture": "http:\/\/res.shiminjia.com\/files\/202108\/02\/111602_750.jpg", "url": "http:\/\/city.shiminjia.com\/html\/zhihuiyouxuan\/#\/detail?id=471" }],
      menus: [

      ],
      active: 0,
      list: [

      ],
      loading: false,
      finished: false,
      refreshing: false,
      timeOutEvent: 0,
      show: -1,
      page: 1,
      totalPages: 0,
      hotk: '',
      scroll: '',
      sort: '',
      option2: [
        { text: '价格排序', value: '' },
        { text: '价格最低', value: 'price-asc' },
        { text: '价格最高', value: 'price-desc' },
      ],
      typeFlag: false,
      price_min: '',
      price_max: '',
    }
  },
  mounted() {
    this.getData()
    this.getFillter()
    this.getHotKey()
  },
  activated() {
    this.$nextTick(() => {
      setTimeout(() => {
        // 也可以使用 
        window.scroll(0, this.$store.state.carrerTouScroll.height)
        // document.getElementsByClassName("page")[0].scrollTop = this.$store.state.carrerTouScroll.height
        // this.$refs.page.scrollTop = this.scroll;
      }, 0);
    });
  },
  beforeRouteLeave(to, from, next) {
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
    this.$store.commit('setCarrerTouScroll', scrollTop)
    console.log(scrollTop)
    next();
  },
  methods: {
    getData() {
      if (this.refreshing) {
        this.list = [];
        this.refreshing = false;
      }
      let params = {
        category: this.active,
        sort: this.sort,
        price_min: this.price_min,
        price_max: this.price_max,
        p: this.page
      }

      this.common.request({
        url: "Index",
        methods: "post",
        params: params,
        callback: res => {
          if (res.data.errcode == 0) {
            this.loading = false
            this.banners = res.data.data.banner
            this.list = res.data.data.data
            this.totalPages = res.data.data.totalPages
            if (this.page >= this.totalPages) {
              this.finished = true
            }
          } else {
            this.loading = false
            this.finished = true;
          }
        }
      })

    },
    toSort(value) {
      this.finished = false
      this.page = 1
      this.list = []
      this.sort = value
      this.getData()
    },
    openType() {
      this.typeFlag = this.typeFlag ? false : true
    },
    submit_sort() {
      this.finished = false
      this.page = 1
      this.list = []
      this.typeFlag = false
      this.getData()
    },
    loadmore() {
      setTimeout(() => {
        if (this.refreshing) {
          this.list = [];
          this.refreshing = false;
        }
        if (this.loading) {
          this.page = this.page + 1
          let params = {
            category: this.active,
            sort: this.sort,
            price_min: this.price_min,
            price_max: this.price_max,
            p: this.page
          }
          this.common.request({
            url: "Index",
            methods: "post",
            params: params,
            callback: res => {
              if (res.data.errcode == 0) {
                this.loading = false;
                this.list = this.list.concat(res.data.data.data)
                this.totalPages = res.data.data.totalPages
                if (this.page >= this.totalPages) {
                  this.finished = true
                }
              } else {
                this.finished = true;
                this.loading = false;
              }
            }
          })

          if (this.page >= this.totalPages) {
            this.finished = true;
          }
        }
      }, 1000);
    },
    getFillter() {
      this.common.request({
        url: 'Fillter',
        methods: 'get',
        params: {},
        callback: res => {
          // console.log(res.data.data)
          this.menus = res.data.data
        }
      })
    },
    getHotKey() {
      this.common.request({
        url: 'HotKW',
        methods: 'get',
        params: {},
        callback: res => {
          // console.log(res.data.data)
          // console.log(Math.random() * res.data.data.length)
          this.hotk = res.data.data[Math.floor(Math.random() * res.data.data.length)].name
        }
      })
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false;
      this.page = 1
      this.list = []

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.getData();
    },
    // 总设备开始长按
    getTouchStart(item, index) {
      let _this = this
      this.timeOutEvent = setTimeout(function () {
        _this.show = index
      }, 500);
    },
    // 手离开 如果500毫秒内就释放，则取消长按事件，
    getTouchEnd() {
      clearTimeout(this.timeOutEvent); // 清空定时器
    },
    gtouchmove() {
      clearTimeout(this.timeOutEvent); //清除定时器
      this.timeOutEvent = 0;
    },
    toDet(item) {
      this.$router.push('/detail?id=' + item.id + '&allow_function_share')
    },
    fillter(item) {
      this.finished = false
      this.active = item.product_category_id
      this.list = []
      this.page = 1
      this.getData()
    },
    jump(item) {
      if (item.url) {
        window.location.href = item.url
      } else {
        return
      }
    }
  },
}
</script>
<style>
.van-swipe__indicator {
  border: 1px solid #fff;
  background-color: transparent;
  opacity: 1;
}
.van-swipe__indicator--active {
  border: 1px solid transparent;
}
.van-list__error-text,
.van-list__finished-text,
.van-list__loading {
  width: 100%;
}
.van-dropdown-menu__bar {
  box-shadow: none !important;
  background: none !important;
}
.van-dropdown-menu__title {
  font-size: 0.14rem;
  color: #666666;
}
</style>
<style lang="less" scoped>
.page {
  padding-bottom: 0.55rem;
  .navbar {
    padding: 0.1rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .search {
      width: calc(100% - 1.1rem);
      height: 0.3rem;
      background-color: #ededed;
      border-radius: 0.15rem;
      background-image: url("../assets/icon_search.png");
      background-size: 0.17rem auto;
      background-position: 0.1rem center;
      background-repeat: no-repeat;
      input {
        width: 100%;
        height: 100%;
        padding-left: 0.35rem;
        font-size: 0.14rem;
        color: #666666;
      }
    }
  }
  .banner {
    margin: 0 0.1rem;
  }
  .navbox {
    padding: 0 0.1rem 0;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    &-item {
      width: calc(100% / 6);
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      .icon {
        width: 0.4rem;
        height: 0.4rem;
        border-radius: 50%;
        text-align: center;
        line-height: 0.4rem;
        img {
          // width: 80%;
          transform: scale(0.5);
          vertical-align: middle;
        }
      }
      p {
        font-size: 0.11rem;
        color: #666666;
        margin: 0 0 0.05rem;
        white-space: nowrap;
      }
      &-active {
        .icon {
          background: #f5f5f5;
        }
        p {
          color: #333;
        }
      }
    }
  }
  .filter {
    width: 100%;
    max-width: 750px;
    height: 0.43rem;
    border-top: 0.01rem solid #f4f4f4;
    border-bottom: 0.01rem solid #f4f4f4;
    padding: 0 0.1rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #fff;
    margin: 0 auto;
    &-select {
      display: flex;
      height: 100%;
      align-items: center;
      & > .item {
        padding: 0 0.05rem;
        line-height: 0.45rem;
        font-size: 0.14rem;
        position: relative;
        color: #666666;
        margin-right: 0.3rem;
      }
      .active {
        color: #333;
        &::after {
          content: "";
          display: block;
          width: 100%;
          height: 0.02rem;
          background-color: #ebd28e;
          position: absolute;
          left: 0;
          bottom: 0;
        }
      }
    }
    &-type {
      line-height: 0.45rem;
      font-size: 0.14rem;
      position: relative;
      color: #666666;
    }
  }
  .sortBox {
    padding: 0 0.15rem 0.15rem;
    & > h3 {
      font-size: 0.14rem;
      color: #333;
    }
    .interval {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 0.15rem;
      & > span {
        width: 3%;
        height: 1px;
        background-color: #ccc;
      }
      & > input {
        width: 45%;
        background-color: #f1f1f1;
        font-size: 0.14rem;
        text-align: center;
        border-radius: 0.17rem;
        height: 0.34rem;
      }
    }

    &-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 0.2rem;
      .item {
        width: 50%;
        height: 0.34rem;
        color: #fff;
        font-size: 0.15rem;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .item_min {
        border-radius: 0.2rem 0px 0px 0.2rem;
        background: linear-gradient(270deg, #ddb253, #f0cd7b);
      }
      .item_max {
        border-radius: 0px 0.2rem 0.2rem 0px;
        background: linear-gradient(270deg, #d51012, #f04d2d);
      }
    }
  }
  .mallbox {
    padding: 0.1rem;
    background-color: #f1f1f1;
    &-list {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      &-item {
        width: calc(50% - 0.05rem);
        margin-bottom: 0.1rem;
        // width: 345px;
        // height: 523px;
        background: #ffffff;
        border-radius: 0.05rem;
        position: relative;
        padding: 5px 0 0;
        .displaying {
          width: 100%;
          height: calc(325px / 2);
          img {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }
        & > .title {
          font-size: 0.14rem;
          color: #333333;
          line-height: 0.21rem;
          display: -webkit-box;
          word-break: break-all;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2; // 需要显示的行数
          overflow: hidden;
          text-overflow: ellipsis;
          margin: 0.08rem 0.05rem;
          // background: url("../assets/icon_JD.png") no-repeat;
          // background-size: 0.16rem auto;
          // background-position: left 0.02rem;
          // text-indent: 0.18rem;
        }
        .price {
          display: flex;
          align-items: flex-end;
          justify-content: space-between;
          margin: 0 0.05rem;
          padding-bottom: 0.09rem;
          p {
            font-size: 0.11rem;
            color: #999999;
            white-space: nowrap;
            display: flex;
            flex-wrap: wrap;
            justify-content: flex-end;
            &:nth-child(1) {
              justify-content: flex-start;
              color: #c90827;
              strong {
                font-size: 0.14rem;
              }
            }
          }
        }
        .mask {
          width: 100%;
          height: 100%;
          border-radius: 0.05rem;
          background-color: rgba(0, 0, 0, 0.5);
          position: absolute;
          left: 0;
          top: 0;
          .wrapper {
            display: flex;
            flex-direction: column;
            align-items: center;
            position: relative;
            width: 100%;
            height: 100%;
            .btn {
              width: 1.22rem;
              height: 0.27rem;
              line-height: 0.27rem;
              background: #ffffff;
              border-radius: 0.13rem;
              text-align: center;
              font-size: 0.14rem;
              color: #333333;
              margin-top: 0.2rem;
            }
            .bot {
              position: absolute;
              left: 0;
              bottom: 0;
              width: 100%;
              font-size: 0.14rem;
              color: #ffffff;
              text-align: center;
              padding: 0.2rem 0;
              background-color: rgba(0, 0, 0, 0.5);
              border-radius: 0 0 0.05rem 0.05rem;
            }
          }
        }
      }
    }
  }
}
</style>
